const players = [
  {
    id: 1,
    name: 'C. Anthony',
    image: 'All-Star-Final-Portraits-01.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 2,
      },
      {
        categoryId: 1,
        divisionId: 1,
        additionalData: 'Knicks',
      },
      {
        categoryId: 2,
        divisionId: 1,
        additionalData: 'Brooklyn',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Brooklyn',
      },
      {
        categoryId: 4,
        divisionId: 1,
        additionalData: 'Big',
      },
      {
        categoryId: 5,
        divisionId: 2,
        additionalData: '6\'8"',
      },
      {
        categoryId: 6,
        divisionId: 2,
        additionalData: '31',
      },
      {
        categoryId: 7,
        divisionId: 1,
        additionalData: 'Syracuse',
      },
      {
        categoryId: 8,
        divisionId: 2,
        additionalData: '0',
      },
      {
        categoryId: 9,
        divisionId: 1,
        additionalData: '$22.8M - 3YRS',
      },
      {
        categoryId: 10,
        divisionId: 1,
        additionalData: 'Jordan',
      },
      {
        categoryId: 11,
        divisionId: 2,
        additionalData: '-0.5',
      },
    ],
  },
  {
    id: 2,
    name: 'C. Bosh',
    image: 'All-Star-Final-Portraits-02.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 2,
      },
      {
        categoryId: 1,
        divisionId: 2,
        additionalData: 'Heat',
      },
      {
        categoryId: 2,
        divisionId: 2,
        additionalData: 'Dallas',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Dallas',
      },
      {
        categoryId: 4,
        divisionId: 2,
        additionalData: 'Small',
      },
      {
        categoryId: 5,
        divisionId: 2,
        additionalData: '6\'11"',
      },
      {
        categoryId: 6,
        divisionId: 2,
        additionalData: '31',
      },
      {
        categoryId: 7,
        divisionId: 1,
        additionalData: 'Georgia Tech',
      },
      {
        categoryId: 8,
        divisionId: 1,
        additionalData: '2',
      },
      {
        categoryId: 9,
        divisionId: 1,
        additionalData: '$22.1M - 4YRS',
      },
      {
        categoryId: 10,
        divisionId: 1,
        additionalData: 'Nike',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '0.3',
      },
    ],
  },
  {
    id: 3,
    name: 'P. Gasol',
    image: 'All-Star-Final-Portraits-03.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 2,
      },
      {
        categoryId: 1,
        divisionId: 1,
        additionalData: 'Bulls',
      },
      {
        categoryId: 2,
        divisionId: 1,
        additionalData: 'Barcelona',
      },
      {
        categoryId: 3,
        divisionId: 2,
        additionalData: 'Spain',
      },
      {
        categoryId: 4,
        divisionId: 1,
        additionalData: 'Big',
      },
      {
        categoryId: 5,
        divisionId: 2,
        additionalData: '7\'0"',
      },
      {
        categoryId: 6,
        divisionId: 2,
        additionalData: '35',
      },
      {
        categoryId: 7,
        divisionId: 1,
        additionalData: 'Europe',
      },
      {
        categoryId: 8,
        divisionId: 1,
        additionalData: '2',
      },
      {
        categoryId: 9,
        divisionId: 2,
        additionalData: '$7.4M - 2YRS',
      },
      {
        categoryId: 10,
        divisionId: 1,
        additionalData: 'Nike',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '3.4',
      },
    ],
  },
  {
    id: 4,
    name: 'A. Drummond',
    image: 'All-Star-Final-Portraits-04.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 2,
      },
      {
        categoryId: 1,
        divisionId: 1,
        additionalData: 'Pistons',
      },
      {
        categoryId: 2,
        divisionId: 1,
        additionalData: 'NYC',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'NYC',
      },
      {
        categoryId: 4,
        divisionId: 2,
        additionalData: 'Small',
      },
      {
        categoryId: 5,
        divisionId: 2,
        additionalData: '7\'0"',
      },
      {
        categoryId: 6,
        divisionId: 1,
        additionalData: '22',
      },
      {
        categoryId: 7,
        divisionId: 1,
        additionalData: 'UConn',
      },
      {
        categoryId: 8,
        divisionId: 2,
        additionalData: '0',
      },
      {
        categoryId: 9,
        divisionId: 2,
        additionalData: '$3.2M - 1YR',
      },
      {
        categoryId: 10,
        divisionId: 1,
        additionalData: 'Jordan',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '1.9',
      },
    ],
  },
  {
    id: 5,
    name: 'P. George',
    image: 'All-Star-Final-Portraits-05.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 2,
      },
      {
        categoryId: 1,
        divisionId: 1,
        additionalData: 'Pacers',
      },
      {
        categoryId: 2,
        divisionId: 2,
        additionalData: 'Los Angeles',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Los Angeles',
      },
      {
        categoryId: 4,
        divisionId: 2,
        additionalData: 'Small',
      },
      {
        categoryId: 5,
        divisionId: 2,
        additionalData: '6\'9"',
      },
      {
        categoryId: 6,
        divisionId: 1,
        additionalData: '25',
      },
      {
        categoryId: 7,
        divisionId: 2,
        additionalData: 'Fresno State',
      },
      {
        categoryId: 8,
        divisionId: 2,
        additionalData: '0',
      },
      {
        categoryId: 9,
        divisionId: 1,
        additionalData: '$17.1M - 3YRS',
      },
      {
        categoryId: 10,
        divisionId: 1,
        additionalData: 'Nike',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '1',
      },
    ],
  },
  {
    id: 6,
    name: 'I. Thomas',
    image: 'All-Star-Final-Portraits-06.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 2,
      },
      {
        categoryId: 1,
        divisionId: 1,
        additionalData: 'Celtics',
      },
      {
        categoryId: 2,
        divisionId: 2,
        additionalData: 'Portland',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Portland',
      },
      {
        categoryId: 4,
        divisionId: 1,
        additionalData: 'Big',
      },
      {
        categoryId: 5,
        divisionId: 1,
        additionalData: '5\'9"',
      },
      {
        categoryId: 6,
        divisionId: 1,
        additionalData: '26',
      },
      {
        categoryId: 7,
        divisionId: 2,
        additionalData: 'Washington',
      },
      {
        categoryId: 8,
        divisionId: 2,
        additionalData: '0',
      },
      {
        categoryId: 9,
        divisionId: 2,
        additionalData: '$7.7M - 3YRS',
      },
      {
        categoryId: 10,
        divisionId: 1,
        additionalData: 'Nike',
      },
      {
        categoryId: 11,
        divisionId: 2,
        additionalData: '-2',
      },
    ],
  },
  {
    id: 7,
    name: 'L. James',
    image: 'All-Star-Final-Portraits-07.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 2,
      },
      {
        categoryId: 1,
        divisionId: 1,
        additionalData: 'Cavaliers',
      },
      {
        categoryId: 2,
        divisionId: 1,
        additionalData: 'Cleveland',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Cleveland',
      },
      {
        categoryId: 4,
        divisionId: 2,
        additionalData: 'Small',
      },
      {
        categoryId: 5,
        divisionId: 2,
        additionalData: '6\'8"',
      },
      {
        categoryId: 6,
        divisionId: 2,
        additionalData: '31',
      },
      {
        categoryId: 7,
        divisionId: 1,
        additionalData: 'St. V. - St. M.',
      },
      {
        categoryId: 8,
        divisionId: 1,
        additionalData: '2',
      },
      {
        categoryId: 9,
        divisionId: 1,
        additionalData: '$22.9M - 1YR',
      },
      {
        categoryId: 10,
        divisionId: 1,
        additionalData: 'Nike',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '2.4',
      },
    ],
  },
  {
    id: 8,
    name: 'D. Wade',
    image: 'All-Star-Final-Portraits-08.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 2,
      },
      {
        categoryId: 1,
        divisionId: 2,
        additionalData: 'Heat',
      },
      {
        categoryId: 2,
        divisionId: 1,
        additionalData: 'Chicago',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Chicago',
      },
      {
        categoryId: 4,
        divisionId: 2,
        additionalData: 'Small',
      },
      {
        categoryId: 5,
        divisionId: 1,
        additionalData: '6\'4"',
      },
      {
        categoryId: 6,
        divisionId: 2,
        additionalData: '34',
      },
      {
        categoryId: 7,
        divisionId: 2,
        additionalData: 'Marquette',
      },
      {
        categoryId: 8,
        divisionId: 1,
        additionalData: '3',
      },
      {
        categoryId: 9,
        divisionId: 1,
        additionalData: '$20M - 1YR',
      },
      {
        categoryId: 10,
        divisionId: 2,
        additionalData: 'Li-Ning',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '',
      },
    ],
  },
  {
    id: 9,
    name: 'K. Lowry',
    image: 'All-Star-Final-Portraits-09.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 2,
      },
      {
        categoryId: 1,
        divisionId: 1,
        additionalData: 'Raptors',
      },
      {
        categoryId: 2,
        divisionId: 1,
        additionalData: 'Philadelphia',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Philadelphia',
      },
      {
        categoryId: 4,
        divisionId: 1,
        additionalData: 'Big',
      },
      {
        categoryId: 5,
        divisionId: 1,
        additionalData: '6\'0"',
      },
      {
        categoryId: 6,
        divisionId: 1,
        additionalData: '29',
      },
      {
        categoryId: 7,
        divisionId: 2,
        additionalData: 'Villanova',
      },
      {
        categoryId: 8,
        divisionId: 2,
        additionalData: '0',
      },
      {
        categoryId: 9,
        divisionId: 2,
        additionalData: '$12M - 2YRS',
      },
      {
        categoryId: 10,
        divisionId: 2,
        additionalData: 'Adidas',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '1.1',
      },
    ],
  },
  {
    id: 10,
    name: 'P. Millsap',
    image: 'All-Star-Final-Portraits-10.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 2,
      },
      {
        categoryId: 1,
        divisionId: 2,
        additionalData: 'Hawks',
      },
      {
        categoryId: 2,
        divisionId: 2,
        additionalData: 'Dallas',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Dallas',
      },
      {
        categoryId: 4,
        divisionId: 1,
        additionalData: 'Big',
      },
      {
        categoryId: 5,
        divisionId: 2,
        additionalData: '6\'8"',
      },
      {
        categoryId: 6,
        divisionId: 2,
        additionalData: '31',
      },
      {
        categoryId: 7,
        divisionId: 2,
        additionalData: 'LA Tech',
      },
      {
        categoryId: 8,
        divisionId: 2,
        additionalData: '0',
      },
      {
        categoryId: 9,
        divisionId: 1,
        additionalData: '$18.6M - 2YRS',
      },
      {
        categoryId: 10,
        divisionId: 2,
        additionalData: '',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '3.1',
      },
    ],
  },
  {
    id: 11,
    name: 'J. Wall',
    image: 'All-Star-Final-Portraits-11.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 2,
      },
      {
        categoryId: 1,
        divisionId: 1,
        additionalData: 'Wizards',
      },
      {
        categoryId: 2,
        divisionId: 1,
        additionalData: 'Charlotte',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Charlotte',
      },
      {
        categoryId: 4,
        divisionId: 1,
        additionalData: 'Big',
      },
      {
        categoryId: 5,
        divisionId: 1,
        additionalData: '6\'4"',
      },
      {
        categoryId: 6,
        divisionId: 1,
        additionalData: '25',
      },
      {
        categoryId: 7,
        divisionId: 1,
        additionalData: 'Kentucky',
      },
      {
        categoryId: 8,
        divisionId: 2,
        additionalData: '0',
      },
      {
        categoryId: 9,
        divisionId: 2,
        additionalData: '$15.8M - 4YRS',
      },
      {
        categoryId: 10,
        divisionId: 2,
        additionalData: 'Adidas',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '3.1',
      },
    ],
  },
  {
    id: 12,
    name: 'D. Derozan',
    image: 'All-Star-Final-Portraits-12.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 2,
      },
      {
        categoryId: 1,
        divisionId: 1,
        additionalData: 'Raptors',
      },
      {
        categoryId: 2,
        divisionId: 2,
        additionalData: 'Los Angeles',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Los Angeles',
      },
      {
        categoryId: 4,
        divisionId: 1,
        additionalData: 'Big',
      },
      {
        categoryId: 5,
        divisionId: 1,
        additionalData: '6\'7"',
      },
      {
        categoryId: 6,
        divisionId: 1,
        additionalData: '26',
      },
      {
        categoryId: 7,
        divisionId: 1,
        additionalData: 'USC',
      },
      {
        categoryId: 8,
        divisionId: 2,
        additionalData: '0',
      },
      {
        categoryId: 9,
        divisionId: 2,
        additionalData: '$9.5M - 1YR',
      },
      {
        categoryId: 10,
        divisionId: 2,
        additionalData: '',
      },
      {
        categoryId: 11,
        divisionId: 2,
        additionalData: '-1.1',
      },
    ],
  },
  {
    id: 13,
    name: 'K. Bryant',
    image: 'All-Star-Final-Portraits-13.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 1,
      },
      {
        categoryId: 1,
        divisionId: 2,
        additionalData: 'Lakers',
      },
      {
        categoryId: 2,
        divisionId: 1,
        additionalData: 'Philadelphia',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Philadelphia',
      },
      {
        categoryId: 4,
        divisionId: 1,
        additionalData: 'Big',
      },
      {
        categoryId: 5,
        divisionId: 1,
        additionalData: '6\'6"',
      },
      {
        categoryId: 6,
        divisionId: 2,
        additionalData: '37',
      },
      {
        categoryId: 7,
        divisionId: 1,
        additionalData: 'Lower Merion',
      },
      {
        categoryId: 8,
        divisionId: 1,
        additionalData: '5',
      },
      {
        categoryId: 9,
        divisionId: 1,
        additionalData: '$25M - 1YR',
      },
      {
        categoryId: 10,
        divisionId: 1,
        additionalData: 'Nike',
      },
      {
        categoryId: 11,
        divisionId: 2,
        additionalData: '-2.8',
      },
    ],
  },
  {
    id: 14,
    name: 'S. Curry',
    image: 'All-Star-Final-Portraits-14.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 1,
      },
      {
        categoryId: 1,
        divisionId: 2,
        additionalData: 'Warriors',
      },
      {
        categoryId: 2,
        divisionId: 1,
        additionalData: 'Cleveland',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Cleveland',
      },
      {
        categoryId: 4,
        divisionId: 1,
        additionalData: 'Big',
      },
      {
        categoryId: 5,
        divisionId: 1,
        additionalData: '6\'3"',
      },
      {
        categoryId: 6,
        divisionId: 1,
        additionalData: '27',
      },
      {
        categoryId: 7,
        divisionId: 2,
        additionalData: 'Davidson',
      },
      {
        categoryId: 8,
        divisionId: 1,
        additionalData: '1',
      },
      {
        categoryId: 9,
        divisionId: 2,
        additionalData: '$11.3M - 2YRS',
      },
      {
        categoryId: 10,
        divisionId: 2,
        additionalData: 'Under Armour',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '0',
      },
    ],
  },
  {
    id: 15,
    name: 'A. Davis',
    image: 'All-Star-Final-Portraits-15.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 1,
      },
      {
        categoryId: 1,
        divisionId: 2,
        additionalData: 'Pelicans',
      },
      {
        categoryId: 2,
        divisionId: 1,
        additionalData: 'Chicago',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Chicago',
      },
      {
        categoryId: 4,
        divisionId: 2,
        additionalData: 'Small',
      },
      {
        categoryId: 5,
        divisionId: 2,
        additionalData: '6\'10"',
      },
      {
        categoryId: 6,
        divisionId: 1,
        additionalData: '22',
      },
      {
        categoryId: 7,
        divisionId: 1,
        additionalData: 'Kentucky',
      },
      {
        categoryId: 8,
        divisionId: 2,
        additionalData: '0',
      },
      {
        categoryId: 9,
        divisionId: 2,
        additionalData: '$7M - 1YR',
      },
      {
        categoryId: 10,
        divisionId: 1,
        additionalData: 'Nike',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '1.8',
      },
    ],
  },
  {
    id: 16,
    name: 'K. Durant',
    image: 'All-Star-Final-Portraits-16.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 1,
      },
      {
        categoryId: 1,
        divisionId: 2,
        additionalData: 'Thunder',
      },
      {
        categoryId: 2,
        divisionId: 1,
        additionalData: 'DC',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'DC',
      },
      {
        categoryId: 4,
        divisionId: 2,
        additionalData: 'Small',
      },
      {
        categoryId: 5,
        divisionId: 2,
        additionalData: '6\'9"',
      },
      {
        categoryId: 6,
        divisionId: 1,
        additionalData: '27',
      },
      {
        categoryId: 7,
        divisionId: 1,
        additionalData: 'Texas',
      },
      {
        categoryId: 8,
        divisionId: 2,
        additionalData: '0',
      },
      {
        categoryId: 9,
        divisionId: 1,
        additionalData: '$20.1M - 1YR',
      },
      {
        categoryId: 10,
        divisionId: 1,
        additionalData: 'Nike',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '0.7',
      },
    ],
  },
  {
    id: 17,
    name: 'D. Green',
    image: 'All-Star-Final-Portraits-17.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 1,
      },
      {
        categoryId: 1,
        divisionId: 2,
        additionalData: 'Warriors',
      },
      {
        categoryId: 2,
        divisionId: 1,
        additionalData: 'Detroit',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Detroit',
      },
      {
        categoryId: 4,
        divisionId: 1,
        additionalData: 'Big',
      },
      {
        categoryId: 5,
        divisionId: 1,
        additionalData: '6\'7"',
      },
      {
        categoryId: 6,
        divisionId: 1,
        additionalData: '25',
      },
      {
        categoryId: 7,
        divisionId: 2,
        additionalData: 'Michigan St.',
      },
      {
        categoryId: 8,
        divisionId: 1,
        additionalData: '1',
      },
      {
        categoryId: 9,
        divisionId: 2,
        additionalData: '$14.3M - 5YRS',
      },
      {
        categoryId: 10,
        divisionId: 1,
        additionalData: 'Nike',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '3.5',
      },
    ],
  },
  {
    id: 18,
    name: 'L. Aldridge',
    image: 'All-Star-Final-Portraits-18.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 1,
      },
      {
        categoryId: 1,
        divisionId: 2,
        additionalData: 'Spurs',
      },
      {
        categoryId: 2,
        divisionId: 2,
        additionalData: 'Dallas',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Dallas',
      },
      {
        categoryId: 4,
        divisionId: 2,
        additionalData: 'Small',
      },
      {
        categoryId: 5,
        divisionId: 2,
        additionalData: '6\'11"',
      },
      {
        categoryId: 6,
        divisionId: 2,
        additionalData: '30',
      },
      {
        categoryId: 7,
        divisionId: 2,
        additionalData: 'Texas',
      },
      {
        categoryId: 8,
        divisionId: 2,
        additionalData: '0',
      },
      {
        categoryId: 9,
        divisionId: 1,
        additionalData: '$19.6M - 3YRS',
      },
      {
        categoryId: 10,
        divisionId: 1,
        additionalData: 'Nike',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '0.8',
      },
    ],
  },
  {
    id: 19,
    name: 'J. Harden',
    image: 'All-Star-Final-Portraits-19.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 1,
      },
      {
        categoryId: 1,
        divisionId: 2,
        additionalData: 'Rockets',
      },
      {
        categoryId: 2,
        divisionId: 2,
        additionalData: 'Los Angeles',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Los Angeles',
      },
      {
        categoryId: 4,
        divisionId: 1,
        additionalData: 'Big',
      },
      {
        categoryId: 5,
        divisionId: 1,
        additionalData: '6\'5"',
      },
      {
        categoryId: 6,
        divisionId: 1,
        additionalData: '26',
      },
      {
        categoryId: 7,
        divisionId: 2,
        additionalData: 'Arizona State',
      },
      {
        categoryId: 8,
        divisionId: 2,
        additionalData: '0',
      },
      {
        categoryId: 9,
        divisionId: 2,
        additionalData: '$15.7M - 3YRS',
      },
      {
        categoryId: 10,
        divisionId: 2,
        additionalData: 'Adidas',
      },
      {
        categoryId: 11,
        divisionId: 2,
        additionalData: '-0.6',
      },
    ],
  },
  {
    id: 20,
    name: 'K. Leonard',
    image: 'All-Star-Final-Portraits-20.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 1,
      },
      {
        categoryId: 1,
        divisionId: 2,
        additionalData: 'Spurs',
      },
      {
        categoryId: 2,
        divisionId: 2,
        additionalData: 'Los Angeles',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Los Angeles',
      },
      {
        categoryId: 4,
        divisionId: 2,
        additionalData: 'Small',
      },
      {
        categoryId: 5,
        divisionId: 1,
        additionalData: '6\'7"',
      },
      {
        categoryId: 6,
        divisionId: 1,
        additionalData: '24',
      },
      {
        categoryId: 7,
        divisionId: 2,
        additionalData: 'SD State',
      },
      {
        categoryId: 8,
        divisionId: 1,
        additionalData: '1',
      },
      {
        categoryId: 9,
        divisionId: 1,
        additionalData: '$16.4M - 4YRS',
      },
      {
        categoryId: 10,
        divisionId: 1,
        additionalData: 'Jordan',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '3.3',
      },
    ],
  },
  {
    id: 21,
    name: 'R. Westbrook',
    image: 'All-Star-Final-Portraits-21.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 1,
      },
      {
        categoryId: 1,
        divisionId: 2,
        additionalData: 'Thunder',
      },
      {
        categoryId: 2,
        divisionId: 2,
        additionalData: 'Los Angeles',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Los Angeles',
      },
      {
        categoryId: 4,
        divisionId: 2,
        additionalData: 'Small',
      },
      {
        categoryId: 5,
        divisionId: 1,
        additionalData: '6\'3"',
      },
      {
        categoryId: 6,
        divisionId: 1,
        additionalData: '27',
      },
      {
        categoryId: 7,
        divisionId: 2,
        additionalData: 'UCLA',
      },
      {
        categoryId: 8,
        divisionId: 2,
        additionalData: '0',
      },
      {
        categoryId: 9,
        divisionId: 1,
        additionalData: '$16.7M - 2YRS',
      },
      {
        categoryId: 10,
        divisionId: 1,
        additionalData: 'Jordan',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '2.6',
      },
    ],
  },
  {
    id: 22,
    name: 'K. Thompson',
    image: 'All-Star-Final-Portraits-22.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 1,
      },
      {
        categoryId: 1,
        divisionId: 2,
        additionalData: 'Warriors',
      },
      {
        categoryId: 2,
        divisionId: 2,
        additionalData: 'Los Angeles',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Los Angeles',
      },
      {
        categoryId: 4,
        divisionId: 1,
        additionalData: 'Big',
      },
      {
        categoryId: 5,
        divisionId: 1,
        additionalData: '6\'7"',
      },
      {
        categoryId: 6,
        divisionId: 1,
        additionalData: '25',
      },
      {
        categoryId: 7,
        divisionId: 2,
        additionalData: 'W. State',
      },
      {
        categoryId: 8,
        divisionId: 1,
        additionalData: '1',
      },
      {
        categoryId: 9,
        divisionId: 2,
        additionalData: '$15.5M - 4YRS',
      },
      {
        categoryId: 10,
        divisionId: 2,
        additionalData: 'Anta',
      },
      {
        categoryId: 11,
        divisionId: 2,
        additionalData: '-2',
      },
    ],
  },
  {
    id: 23,
    name: 'C. Paul',
    image: 'All-Star-Final-Portraits-23.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 1,
      },
      {
        categoryId: 1,
        divisionId: 2,
        additionalData: 'Clippers',
      },
      {
        categoryId: 2,
        divisionId: 1,
        additionalData: 'Charlotte',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'Charlotte',
      },
      {
        categoryId: 4,
        divisionId: 1,
        additionalData: 'Big',
      },
      {
        categoryId: 5,
        divisionId: 1,
        additionalData: '6\'0"',
      },
      {
        categoryId: 6,
        divisionId: 2,
        additionalData: '30',
      },
      {
        categoryId: 7,
        divisionId: 2,
        additionalData: 'Wake Forest',
      },
      {
        categoryId: 8,
        divisionId: 2,
        additionalData: '0',
      },
      {
        categoryId: 9,
        divisionId: 1,
        additionalData: '$21.4M - 2YRS',
      },
      {
        categoryId: 10,
        divisionId: 1,
        additionalData: 'Jordan',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '0.1',
      },
    ],
  },
  {
    id: 24,
    name: 'D. Cousins',
    image: 'All-Star-Final-Portraits-24.png',
    categories: [
      {
        categoryId: 0,
        divisionId: 1,
      },
      {
        categoryId: 1,
        divisionId: 2,
        additionalData: 'Kings',
      },
      {
        categoryId: 2,
        divisionId: 2,
        additionalData: 'New Orleans',
      },
      {
        categoryId: 3,
        divisionId: 1,
        additionalData: 'New Orleans',
      },
      {
        categoryId: 4,
        divisionId: 2,
        additionalData: 'Small',
      },
      {
        categoryId: 5,
        divisionId: 2,
        additionalData: '6\'11"',
      },
      {
        categoryId: 6,
        divisionId: 1,
        additionalData: '25',
      },
      {
        categoryId: 7,
        divisionId: 1,
        additionalData: 'Kentucky',
      },
      {
        categoryId: 8,
        divisionId: 2,
        additionalData: '0',
      },
      {
        categoryId: 9,
        divisionId: 2,
        additionalData: '$15.8M - 3YRS',
      },
      {
        categoryId: 10,
        divisionId: 2,
        additionalData: '',
      },
      {
        categoryId: 11,
        divisionId: 1,
        additionalData: '1',
      },
    ],
  },
];

export default players;
